import script from "./SuspensionInstructions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuspensionInstructions.vue?vue&type=script&setup=true&lang=ts"

import "./SuspensionInstructions.vue?vue&type=style&index=0&id=d62af76e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1501305b0fb1954c01d0b4f35a9e823f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d62af76e"]])

export default __exports__